import { Box, styled } from '@mui/material';
import { ReactElement } from 'react';

const StyledLine = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    color: theme.palette.grey[700],
    margin: theme.spacing(0, 0.75),
    height: theme.spacing(7),
}));

export const FilterLine = (): ReactElement => {
    return <StyledLine>&ndash;</StyledLine>;
};
